import { render, staticRenderFns } from "./PianoColtivazione.vue?vue&type=template&id=9c47cce2&scoped=true&"
import script from "./PianoColtivazione.vue?vue&type=script&lang=js&"
export * from "./PianoColtivazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c47cce2",
  null
  
)

export default component.exports